import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';
import { FixMeLaterApi } from 'src/types';
import { usePermissions } from 'src/hooks';
import { manufacturerStatusOptions } from 'src/redux/slices/manufacturer/constants';
import { colors } from 'src/constants';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { Pagination } from '@material-ui/lab';

const {
  selectors: manufacturerSelectors,
  actions: manufacturerActions
} = slices.manufacturer;

interface Props {
  manufacturers: FixMeLaterApi;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const Manufacturers = ({ className, ...rest }: Props) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { canEditManufacturer } = usePermissions();

  const manufacturersData = useAppSelector(
    manufacturerSelectors.selectManufacturers
  );

  const manufacturerMeta = useAppSelector(
    manufacturerSelectors.selectManufacturerMeta
  );

  const onManufacturerPress = (item: FixMeLaterApi) => {
    canEditManufacturer &&
      navigate(`/app/manufacturers/${item.id}`, {
        replace: false,
        state: item
      });
  };

  const onHandlePageChange = (page_num?: number) => {
    dispatch(manufacturerActions.getManufacturersThunk({ page: page_num }));
  };

  const poStatusColor = useCallback((status?: string) => {
    const selectedColor = manufacturerStatusOptions?.find(
      (option) => option.value === status
    )?.color;
    return selectedColor || colors.black[500];
  }, []);

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Manufacturer Name</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {manufacturersData.map((item: FixMeLaterApi) => (
                <TableRow
                  onClick={() => onManufacturerPress(item)}
                  hover
                  key={item.id}
                >
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    <Chip
                      style={{
                        color: poStatusColor(
                          item?.is_end_date ? 'inactive' : 'active'
                        ),
                        borderColor: poStatusColor(
                          item?.is_end_date ? 'inactive' : 'active'
                        )
                      }}
                      label={
                        <Typography variant="subtitle2">
                          {item?.is_end_date ? 'Inactive' : 'Active'}
                        </Typography>
                      }
                      size="small"
                      variant="outlined"
                      color="default"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Pagination
            count={manufacturerMeta?.last_page || 1}
            page={manufacturerMeta?.current_page || 1}
            onChange={(e, p) => onHandlePageChange(p)}
          />
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

export default Manufacturers;
